import React from "react";
import SupplierDetailsMain from "../../components/SupplierDetailsMain";

const SupplierDetailsPage = () => {
  return (
    <React.Fragment>
      <SupplierDetailsMain />
    </React.Fragment>
  );
};

export default SupplierDetailsPage;
